/* eslint-disable no-console, no-unused-vars */
import { inject } from 'vue'

export const FRONTEND_LOGGER_KEY = Symbol('frontend-logger')

export class FrontendLogger {
  info(_message, ..._args) {}
  warn(_message, ..._args) {}
  error(_message, ..._args) {}
  debug(_message, ..._args) {}

  child(prefix) {
    return new PrefixedFrontendLogger(this, prefix)
  }
}

class PrefixedFrontendLogger extends FrontendLogger {
  constructor(parent, prefix) {
    super()
    this.parent = parent
    this.prefix = prefix
  }

  info(message, ...args) {
    this.parent.info(this.format(message), ...args)
  }

  warn(message, ...args) {
    this.parent.warn(this.format(message), ...args)
  }

  error(message, ...args) {
    this.parent.error(this.format(message), ...args)
  }

  debug(message, ...args) {
    this.parent.debug(this.format(message), ...args)
  }

  format(message) {
    return `${this.prefix} ${message}`
  }
}

export class ConsoleFrontendLogger extends FrontendLogger {
  info(message, ...args) {
    console.info(message, ...args)
  }

  warn(message, ...args) {
    console.warn(message, ...args)
  }

  error(message, ...args) {
    console.error(message, ...args)
  }

  debug(message, ...args) {
    console.debug(message, ...args)
  }
}

export const appFrontendLogger = new ConsoleFrontendLogger()

export function useFrontendLogger() {
  return inject(FRONTEND_LOGGER_KEY, appFrontendLogger)
}
